var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloorplan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.332031 0.666504H7.56692L12.4296 3.25993L11.5678 4.2953L7.09714 1.91095H1.88759V18.0887H9.66537V10.6221H6.55425V9.37761H14.332V10.6221H11.2209V18.0887H22.1098V10.6221H18.9987V9.37761H22.1098V1.91095H15.8876V0.666504H23.6654V19.3332H0.332031V0.666504Z",
    fill: "#034A73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorplan);
export default __webpack_public_path__ + "static/media/floorplan.8ce6cc4d50a8e0704269635ceb3e4285.svg";
export { ForwardRef as ReactComponent };